module.exports = __webpack_public_path__ + "img/facebook.62f9879a.svg";